import { 
  collection,
  getDocs,
  query,
  where,
  orderBy,
  QuerySnapshot,
  DocumentData
} from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';

export async function queryCollection<T>(
  collectionName: string,
  orderField: string,
  defaultData: T[]
): Promise<T[]> {
  try {
    const collectionRef = collection(db, collectionName);
    let snapshot: QuerySnapshot<DocumentData>;

    try {
      // First try with compound query
      const q = query(
        collectionRef,
        where('status', '==', 'active'),
        orderBy(orderField, 'asc')
      );
      snapshot = await getDocs(q);
    } catch (error: any) {
      if (error.code === 'failed-precondition') {
        // If compound query fails, try simple query
        const q = query(collectionRef, where('status', '==', 'active'));
        snapshot = await getDocs(q);
      } else {
        throw error;
      }
    }

    if (snapshot!.empty) {
      console.info(`No documents found in ${collectionName}, using default data`);
      return defaultData;
    }

    const documents = snapshot!.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as T[];

    // Sort manually if compound query failed
    return documents.sort((a: any, b: any) => 
      (a[orderField] || 0) - (b[orderField] || 0)
    );
  } catch (error: any) {
    console.warn(`Error fetching ${collectionName}:`, error);
    return defaultData;
  }
}